<template>
	<fieldset class="fieldset">
		<div class="form-row">
			<field-box name="property_real_estate[real_estate_type]" :label="$t('forms.real_estate_type')" type="select" :options="realEstateTypeOptions" :disabled="disabled" :has-error="errors?.['property_real_estate.real_estate_type']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_real_estate[street]" :label="$t('forms.street')" type="text" :value="data?.street" :disabled="disabled" :has-error="errors?.['property_real_estate.street']?.length"/>
			<field-box name="property_real_estate[street_number]" :label="$t('forms.street_number')" type="text" :value="data?.street_number" :disabled="disabled" :has-error="errors?.['property_real_estate.street_number']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_real_estate[city]" :label="$t('forms.city')" type="text" :value="data?.city" :disabled="disabled" :has-error="errors?.['property_real_estate.city']?.length"/>
			<field-box name="property_real_estate[zip]" :label="$t('forms.zip')" type="text" :value="data?.zip" :disabled="disabled" :has-error="errors?.['property_real_estate.zip']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_real_estate[floor]" :label="$t('forms.floor')" type="number" :value="data?.floor" :disabled="disabled" :has-error="errors?.['property_real_estate.zip']?.length"/>
			<field-box name="property_real_estate[rooms]" :label="$t('forms.rooms')" type="number" :value="data?.rooms" :disabled="disabled" :has-error="errors?.['property_real_estate.rooms']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_real_estate[bathrooms]" :label="$t('forms.bathrooms')" type="number" :value="data?.bathrooms" :disabled="disabled" :has-error="errors?.['property_real_estate.bathrooms']?.length"/>
			<field-box name="property_real_estate[area]" :label="$t('forms.area')" type="number" :value="data?.area" :disabled="disabled" :has-error="errors?.['property_real_estate.area']?.length"/>
		</div>
		<div class="form-row">
			<field-box name="property_real_estate[flood_zone]" :label="$t('forms.flood_zone')" type="select" :options="floodAreaOptions" :disabled="disabled" :has-error="errors?.['property_real_estate.flood_zone']?.length"/>
		</div>
	</fieldset>
</template>

<script>

import DefaultFieldBox from "@/components/form-fields/DefaultFieldBox.vue";
import FieldBox from "@/components/form-fields/FieldBox.vue";

export default {
	name: "PropertyRealEstateFieldset",
	props: ['data', 'disabled', 'errors'],
	components: {
		DefaultFieldBox,
		FieldBox
	},
	computed: {
		realEstateTypeOptions() {
			let options = [
				{
					value: '',
					title: this.$t('forms.choose')
				},
				{
					value: 'house',
					title: this.$t('forms.real_estate_house'),
				},
				{
					value: 'flat',
					title: this.$t('forms.real_estate_flat'),
				},
				{
					value: 'holiday_house',
					title: this.$t('forms.real_estate_holiday_house'),
				}
			];


			if(this.data){
				options.forEach(item => {
					if (item.value === this.data?.real_estate_type) {
						item.selected = true;
					}
				});
			}

			return options;
		},
		floodAreaOptions(){
			let options = [
				{
					value: '',
					title: this.$t('forms.choose')
				},
				{
					value: 1,
					title: this.$t('general.yes'),
				},
				{
					value: 0,
					title: this.$t('general.no'),
				},
			];


			if(this.data){
				options.forEach(item => {
					if (item.value === this.data?.flood_zone) {
						item.selected = true;
					}
				});
			}

			return options;
		}
	}
}
</script>

<style scoped lang="scss">
fieldset {
	margin: 0;
	padding: 0;
	margin-inline: 0;
	padding-block: 0;
	padding-inline: 0;
	border: none;
}


.form-row {
	margin-bottom: 15px;

	&:last-child {
		margin-bottom: 0;
	}

	&.two-columns {
		display: flex;
		justify-content: space-between;
		flex-direction: row;

		.field-box {
			width: calc(50% - 8px);
		}
	}
}

@media($mobileS) {
	.form-row {
		margin-bottom: 10px;

		&.two-columns {
			flex-direction: column;

			.field-box {
				width: 100%;
				margin-bottom: 10px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}

</style>